import { Link, generatePath, useLocation } from 'react-router-dom';
import { buildBreadcrumbsFromMatches, getBreadcrumbMatches } from '../../util/routeBreadcrumbs';

function usesSectionBreadcrumbGap(pathname) {
  const path = String(pathname || '').toLowerCase();
  return path.startsWith('/help/documentation') || path.startsWith('/admin');
}

function Breadcrumbs({ labels = {}, className = '' }) {
  const { pathname } = useLocation();
  const crumbs = buildBreadcrumbsFromMatches(getBreadcrumbMatches(pathname), labels);
  const path = String(pathname || '').toLowerCase();
  const sectionClass = usesSectionBreadcrumbGap(pathname) ? 'breadcrumbs-section' : '';
  const adminClass = path.startsWith('/admin') ? 'breadcrumbs-admin' : '';

  if (crumbs.length === 0) {
    return null;
  }

  return (
    <nav aria-label="Breadcrumb" className={['breadcrumbs', sectionClass, adminClass, className].filter(Boolean).join(' ')}>
      <ol className="breadcrumbs-list">
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;
          const href = crumb.to
            ? generatePath(crumb.to, crumb.params)
            : generatePath(crumb.pathname, crumb.params);

          return (
            <li key={`${crumb.label}-${index}`} className="breadcrumbs-item">
              {isLast ? (
                <span aria-current="page">{crumb.label}</span>
              ) : (
                <Link to={href}>{crumb.label}</Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default Breadcrumbs;
